import { connect } from 'react-redux';
import ClientMapping from './clientMapping';
import { bindActionCreators } from 'redux';
import {
  getClientAddressForContractMapping,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    clientAddressData: state.siteListingReducer.clientAddressesMapping
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getClientAddressForContractMapping
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ClientMapping);
